<span *ngIf="isValidField()"
      class="form-text text-danger">
                        {{ getFieldError() }}
</span>
